/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonQueryResponse,
  GetApiV1PersonQueryParams,
  GetApiV1Person401,
  GetApiV1Person500,
} from "../../types/personRegisterController/GetApiV1Person.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1Person } from "../../clients/personRegisterController/getApiV1Person.ts";

export const getApiV1PersonQueryKey = (params?: GetApiV1PersonQueryParams) =>
  [{ url: "/api/v1/person" }, ...(params ? [params] : [])] as const;

export type GetApiV1PersonQueryKey = ReturnType<typeof getApiV1PersonQueryKey>;

export function getApiV1PersonQueryOptions(
  params?: GetApiV1PersonQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonQueryKey(params);
  return queryOptions<
    GetApiV1PersonQueryResponse,
    ResponseErrorConfig<GetApiV1Person401 | GetApiV1Person500>,
    GetApiV1PersonQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1Person(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna uma lista paginada de pessoas com filtros opcionais. **(Requer Authorization para autenticação)**
 * @summary Listar pessoas (Requer Authorization para autenticação)
 * {@link /api/v1/person}
 */
export function useGetApiV1Person<
  TData = GetApiV1PersonQueryResponse,
  TQueryData = GetApiV1PersonQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonQueryKey,
>(
  params?: GetApiV1PersonQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonQueryResponse,
        ResponseErrorConfig<GetApiV1Person401 | GetApiV1Person500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getApiV1PersonQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1PersonQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiV1Person401 | GetApiV1Person500>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
